import { z } from 'zod';
const RecentTourneyWinnerSchema = z.object({
    mttName: z.string(),
    autoMttId: z.number(),
    winnerId: z.number(),
    winnerName: z.string()
});
const RecentTourneyWinnersSchema = z.array(RecentTourneyWinnerSchema);
export function recentTourneyWinnersParser(str) {
    try {
        const parsed = JSON.parse(str);
        const valid = RecentTourneyWinnersSchema.parse(parsed);
        return valid;
    }
    catch {
        // return default
    }
    return [];
}
export const RECENT_TOURNEY_WINNERS_PAYLOAD_DEFINITION = {
    isRawParam: true,
    definitionParts: [{ name: 'recentTourneyWinners', parser: recentTourneyWinnersParser }]
};
